import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/landing_top_bg.png")